import React from "react";
import { numberWithComma } from "../../../utility";

const EmployeeDetailsCard = ({ employeeDetails, payout, leaveBalance }) => {
  return (
    <div className="lg:flex flex-row mt-8 gap-x-8 space-y-8 lg:space-y-0">
      {/* Left Employee Details Table */}
      <table className="lg:min-w-[35rem] lg:w-[40%] w-full">
        <thead>
          <tr>
            <th
              colSpan="2"
              className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white"
            >
              Employee Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-bold border py-3 px-4">Employee Name</td>
            <td className="border py-3 px-4">
              {employeeDetails?.employee_name || "----"}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Designation</td>
            <td className="border py-3 px-4">
              {employeeDetails?.designation || "----"}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Group</td>
            <td className="border py-3 px-4">
              {employeeDetails?.department || "----"}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Code</td>
            <td className="border py-3 px-4">
              {employeeDetails?.code || "----"}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">PF No.</td>
            <td className="border py-3 px-4">
              {employeeDetails?.pf_account_number || "----"}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Right Employee Details Table */}
      <table className="lg:min-w-[35rem] lg:w-[40%] w-full">
        <thead>
          <tr>
            <th
              colSpan="2"
              className="font-bold border py-3 px-4 bg-[color:var(--color1)] text-white"
            >
              Employee Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-bold border py-3 px-4">ESI No.</td>
            <td className="border py-3 px-4">
              {employeeDetails?.esi_insurance_number || "----"}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Paid Days</td>
            <td className="border py-3 px-4">
              {payout?.total_paid_days || "----"}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Unpaid Days</td>
            <td className="border py-3 px-4">
              {payout?.total_absent_days || "----"}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Opening Leave Balance</td>
            <td className="border py-3 px-4">
              {leaveBalance?.opening_leave_balance}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Closing Leave Balance</td>
            <td className="border py-3 px-4">
              {leaveBalance?.closing_leave_balance}
            </td>
          </tr>
          <tr>
            <td className="font-bold border py-3 px-4">Gross Salary</td>
            <td className="border py-3 px-4">
              {numberWithComma(Math.round(payout?.gross_salary)) || 0}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeDetailsCard;
